// Read the last completed assessment snapshot from localStorage (written by /result on mount).
// Shape: { assessment_id, total_score, dimension_scores: {physical, mental, ...}, saved_at }

const KEY = 'clinity_last_assessment';
const RETURN_KEY = 'clinity_return_to';

export function getLastAssessment() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (typeof p?.total_score !== 'number' || !p?.dimension_scores) return null;
    return p;
  } catch (_) {
    return null;
  }
}

const DIM_LABELS = {
  physical: 'Physical',
  mental: 'Mental',
  emotional: 'Emotional',
  financial: 'Financial',
  career: 'Career',
  lifestyle: 'Lifestyle',
  spiritual: 'Spiritual',
  self_care: 'Self-Care',
};

/**
 * Rank dimensions by score. Returns:
 *   strongest: top 2 (highest scores)
 *   weakest:   bottom 2 (lowest scores) — the "areas with room to improve"
 * Each entry is { key, label, score }.
 */
export function rankDimensions(dimensionScores) {
  if (!dimensionScores) return { strongest: [], weakest: [] };
  const rows = Object.entries(dimensionScores)
    .filter(([, v]) => typeof v === 'number')
    .map(([k, v]) => ({ key: k, label: DIM_LABELS[k] || k, score: v }));
  const sortedHigh = [...rows].sort((a, b) => b.score - a.score);
  const sortedLow  = [...rows].sort((a, b) => a.score - b.score);
  return { strongest: sortedHigh.slice(0, 2), weakest: sortedLow.slice(0, 2) };
}

export function joinLabels(items) {
  const labels = items.map((i) => i.label);
  if (labels.length <= 1) return labels[0] || '';
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
}

/**
 * Persist a "return to" path so /result can show a "Continue to X" prompt after assessment.
 */
export function setReturnTo(path) {
  try {
    if (path) localStorage.setItem(RETURN_KEY, path);
    else localStorage.removeItem(RETURN_KEY);
  } catch (_) { /* noop */ }
}

export function getReturnTo() {
  try { return localStorage.getItem(RETURN_KEY); } catch (_) { return null; }
}

export function clearReturnTo() {
  try { localStorage.removeItem(RETURN_KEY); } catch (_) { /* noop */ }
}
